const extractNumericValue = (value: any): number | null => {
    if (typeof value === 'number') {
        return value;
    }
    if (value && typeof value === 'object') {
        if ('value' in value) {
            return extractNumericValue(value.value);
        }
        if ('id' in value) {
            return extractNumericValue(value.id);
        }
    }
    return null;
};

export interface IBidderLite {
    id: number;
    name: string;
    agencyId: number | null;
    enabled: boolean;
    status: string;
    pauseReasons?: string[];
}

interface IRawBidderLite {
    id?: any;
    name?: string | null;
    title?: string | null;
    agencyId?: any;
    enabled?: boolean | null;
    status?: string | null;
    pauseReasons?: string[] | null;
}

export const adaptBidderLite = (bidder: IRawBidderLite): IBidderLite | null => {
    const id = extractNumericValue(bidder?.id);
    if (id == null) {
        return null;
    }
    return {
        id,
        name: bidder?.name ?? bidder?.title ?? '',
        agencyId: extractNumericValue(bidder?.agencyId),
        enabled: Boolean(bidder?.enabled),
        status: bidder?.status ?? 'unknown',
        pauseReasons: bidder?.pauseReasons ?? []
    };
};

export const humanizePauseReason = (reason: string): string => {
    const spaced = reason.replace(/_/g, ' ');
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const bidderStatusTags = (bidder: IBidderLite): string[] =>
    bidder.pauseReasons?.length
        ? [bidder.status, ...bidder.pauseReasons.map(humanizePauseReason)]
        : [bidder.status];
